import Parse from 'parse'
import {ParseDbService, artistSchema as Schema} from "./parse.db.service";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.ArtistClassName)
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.name, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    name: item.get(Schema.name)
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let Artist = Parse.Object.extend(ParseDbService.ArtistClassName, null, null);
    let artistObj = new Artist();
    artistObj.set(Schema.name, item.name.toLowerCase());
    return artistObj.save();
}

function edit(item) {
    let artistObj = item.parseItem;
    artistObj.set(Schema.name, item.name.toLowerCase());
    return artistObj.save();
}

export const ArtistService = {
    getAll,
    add,
    edit
};